import type { OrganisationPlan } from 'app/hooks/useOrganisationFeatures';

/**
 * The existing customers the move to the new plans gave features to: Legacy customers (now
 * `legacy-starter`) and Plus or Bespoke customers, in both cases without Pro. Customers with Pro
 * gained nothing.
 */
export type NewPlansSegment = 'legacy-without-pro' | 'plus-without-pro';

export default function newPlansSegment(
  plan: OrganisationPlan | undefined,
  isPro: boolean
): NewPlansSegment | null {
  if (isPro) return null;
  if (plan === 'legacy-starter') return 'legacy-without-pro';
  if (plan === 'plus' || plan === 'bespoke') return 'plus-without-pro';

  return null;
}
